export const tokenResult = {
  access_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJyZjZZMk1JdjhjRER0NHVPay1tVEpfakpSMDdmS2NvSlNhREZqdEd1NzlZIn0.eyJleHAiOjE3NDgzNTAzMDgsImlhdCI6MTc0ODM0ODUwOCwiYXV0aF90aW1lIjoxNzQ4MzQ4MDE0LCJqdGkiOiI5ZjU2NzE4ZC0zYjVmLTRkMTMtOTQ5MC1iYTY4ZDZjNzUwZWMiLCJpc3MiOiJodHRwczovL2lkLmF1LnRlc3QudG9tcmEuY2xvdWQvYXV0aC9yZWFsbXMvVG9tcmFDb25uZWN0VXNlcnMiLCJhdWQiOlsiYWNjb3VudC1tYW5hZ2VtZW50IiwibXl0b21yYS1hcGkiLCJ2b3VjaGVyLWNvbnRyb2wtYXBpIiwiYXNzb3J0bWVudC1tYW5hZ2VtZW50LWFwaSIsImJhcmNvZGUtbWFuYWdlci1hcGkiLCJteXRvbXJhLWNoYXJpdHktYXBpIiwiYWNjb3VudCJdLCJzdWIiOiJlNGI0OGE2Zi02YWZmLTRmNGItODA5OS0yOThiMTJlNmE0ZmYiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJteXRvbXJhLWhvdGxpbmUtdG9vbC11aSIsInNpZCI6IjE0ZGJjMzYwLWQ0ZTQtNGE0YS1iOTg5LTUzN2JlZGM1ODBiZSIsImFjciI6IjAiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9teXRvbXJhLWhvdGxpbmUuYXUudGVzdC50b21yYS5jbG91ZCIsIioiLCJodHRwczovL2F1LnRlc3QubXl0b21yYS1tYW5hZ2VyLnRvbXJhLmNsb3VkIl0sInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwic2NvcGVkX3Jlc291cmNlX2FjY2VzcyI6WyJEZXZlbG9wZXJQb3J0YWwjVXNlciNkNzMzZTk4NS1lZDFhLTRiNGYtYmNmNy0zNzhkZDIzNzhjM2MjREVWRUxPUEVSX1BPUlRBTF9SRUFEIl0sIm5hbWUiOiJFbGluIFN1bmRlIFdpbGJlcmciLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJlbGluLnN1bmRlLndpbGJlcmdAdG9tcmEuY29tIiwiZ2l2ZW5fbmFtZSI6IkVsaW4gU3VuZGUiLCJmYW1pbHlfbmFtZSI6IldpbGJlcmciLCJmdWxsX3Jlc291cmNlX2FjY2VzcyI6WyJBQ0NPVU5UX0FETUlOIiwiTElTVF9JTlNUQUxMQVRJT05TX0ZPUl9VU0VSIiwiTElTVF9BQ1RJVkVfVVNFUlNfRk9SX1BST0RVQ1QiLCJMSVNUX0FQSV9QUk9EVUNUU19GT1JfVVNFUiIsIklOU1RBTExBVElPTl9IQVNfQUNUSVZFX0xJQ0VOU0VfT05fUFJPRFVDVCIsIlVOQ0xBSU1FRF9CQUdTIiwiTVlUT01SQV9NQU5BR0VSX05PVEVTX1dSSVRFIiwiTVlUT01SQV9NQU5BR0VSX1dSSVRFIiwiTVlUT01SQV9FWFRFUk5BTF9MT0NBVElPTl9XUklURSIsIk1ZVE9NUkFfQkFDS09GRklDRV9SRUFEIiwiVk9VQ0hFUl9DT05UUk9MX0FETUlOX01BQ0hJTkVfU0VBUkNIIiwiVk9VQ0hFUl9DT05UUk9MX0FETUlOIiwiVk9VQ0hFUl9DT05UUk9MX0FETUlOX1NUQVRJU1RJQ1NfU0VBUkNIIiwiVk9VQ0hFUl9DT05UUk9MX0FETUlOX01BTkFHRV9TT0FQX0NMSUVOVFMiLCJWT1VDSEVSX0NPTlRST0xfQURNSU5fRVhQT1JUX1JFQ0VJUFQiLCJXUklURV9DT01NT05fQVNTT1JUTUVOVCIsIlZJRVdfQVNTT1JUTUVOVF9NQU5BR0VNRU5UIiwiV1JJVEVfSU5TVEFMTEFUSU9OX0FTU09SVE1FTlQiLCJXUklURV9BU1NPUlRNRU5UX0ZJTEVTIiwiQkFSQ09ERV9SRUFEIiwiQkFSQ09ERV9XUklURSIsIk1ZVE9NUkFfQ0hBUklUSUVTX1JFQUQiLCJNWVRPTVJBX0NIQVJJVElFU19XUklURSIsIk1ZVE9NUkFfQ0hBUklUSUVTX0JBQ0tPRkZJQ0UiLCJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl0sImVtYWlsIjoiZWxpbi5zdW5kZS53aWxiZXJnQHRvbXJhLmNvbSJ9.HEzWj-IRZYi2WVMIAgQV8RgFV7FwKYu-lFpKl3kCTpDx-ATzGOj3IDN9qPZnF4U81USzHe4aXNHSa9y8xOu-h2M0d0jkjt-7UkOaQfxouCTBK5MM7PA13ZnyHi-H_YNmDEcf2r2bX_sci7-pdEIoE942Cef9gcaf9rRxlmJUcc5_iCM5I35_6vm39M6bRD8YhMZeVydwLNiGMaSSIMRACjCbH4NC5HpKIiu0eDhVUFgwqMs0UHgtLqekgU09LBqdep7TZ7JKKctWl2plAzrmXqQRMx84a-vHQmKeP18Gq5LED5t9S4Mpu3mAgXheo2n9Q8pGaf_qCVJeO8ScEjI6yg',
  expires_in: 1800,
  refresh_expires_in: 31535506,
  refresh_token:
    'eyJhbGciOiJIUzUxMiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI5ZWMzZGUwOC02ZjA2LTRlMGUtYTk0YS05YjVjMzZhMWZiNTAifQ.eyJleHAiOjE3Nzk4ODQwMTQsImlhdCI6MTc0ODM0ODUwOCwianRpIjoiZDgwNzIwZjktM2FiMC00NTcyLWJhMDYtOGRhMmJkNTczYTM5IiwiaXNzIjoiaHR0cHM6Ly9pZC5hdS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwiYXVkIjoiaHR0cHM6Ly9pZC5hdS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwic3ViIjoiZTRiNDhhNmYtNmFmZi00ZjRiLTgwOTktMjk4YjEyZTZhNGZmIiwidHlwIjoiUmVmcmVzaCIsImF6cCI6Im15dG9tcmEtaG90bGluZS10b29sLXVpIiwic2lkIjoiMTRkYmMzNjAtZDRlNC00YTRhLWI5ODktNTM3YmVkYzU4MGJlIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBhY3Igd2ViLW9yaWdpbnMgYmFzaWMgcm9sZXMifQ.QlXMoL_LAdOVj0-3AymFADNzcOeY72w9Oneh-4EXakztwIGHS-w6WkIazywOqX8JoScd8JF1GD0pQSEQpgwoVA',
  token_type: 'Bearer',
  id_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJyZjZZMk1JdjhjRER0NHVPay1tVEpfakpSMDdmS2NvSlNhREZqdEd1NzlZIn0.eyJleHAiOjE3NDgzNTAzMDgsImlhdCI6MTc0ODM0ODUwOCwiYXV0aF90aW1lIjoxNzQ4MzQ4MDE0LCJqdGkiOiI0YTBlYWQzYi04YWM4LTQ2MjQtYjY5MC1lYTQ0NDIzYmJkYzMiLCJpc3MiOiJodHRwczovL2lkLmF1LnRlc3QudG9tcmEuY2xvdWQvYXV0aC9yZWFsbXMvVG9tcmFDb25uZWN0VXNlcnMiLCJhdWQiOiJteXRvbXJhLWhvdGxpbmUtdG9vbC11aSIsInN1YiI6ImU0YjQ4YTZmLTZhZmYtNGY0Yi04MDk5LTI5OGIxMmU2YTRmZiIsInR5cCI6IklEIiwiYXpwIjoibXl0b21yYS1ob3RsaW5lLXRvb2wtdWkiLCJub25jZSI6Ijg1OWFiZTQwLTM5NWEtNDIwZC05YTgyLWMxNjNmNGM1MDFmMiIsInNpZCI6IjE0ZGJjMzYwLWQ0ZTQtNGE0YS1iOTg5LTUzN2JlZGM1ODBiZSIsImF0X2hhc2giOiJGTmc3SXhMSHdmcmdIV241RDRnT2NBIiwiYWNyIjoiMCIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiRWxpbiBTdW5kZSBXaWxiZXJnIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiZWxpbi5zdW5kZS53aWxiZXJnQHRvbXJhLmNvbSIsImdpdmVuX25hbWUiOiJFbGluIFN1bmRlIiwiZmFtaWx5X25hbWUiOiJXaWxiZXJnIiwiZW1haWwiOiJlbGluLnN1bmRlLndpbGJlcmdAdG9tcmEuY29tIn0.Gc0BOUNRjm3rbeqJRQ3DfpmFgu3o54pP5OOxLnIe7S05HcduZkABGljHhKhgAtc23WteIDYSnnIPSCm4jSQpZyjIqcUBxOlMa7VKylRPzHwS_spVyvaJpyCDkYvf3qv8CV3u22l_EBJsNqLSblIFQn0Y3PD1sy6_b48tsxb0PbrzIbKxKTrOrkEuijrb2m5rZsYoqd_UVgxv-QmiA17WGuWjfkYbnI0tI5sQNbZbbQ3fuHC-bcfs5w2GPBT3CNQDToJR_5q8Qpaza1t31h0v7l1oyhlMcmANzbFeE-2TktDMIFoAsm6acDpTYLEYdtTKFb9FYJqrzIjE4O20uP1Gfw',
  'not-before-policy': 0,
  session_state: '14dbc360-d4e4-4a4a-b989-537bedc580be',
  scope: 'openid profile email'
}

export const userSearchResponse = {
  data: [
    {
      firstName: 'Test',
      lastName: 'Test',
      email: 'test01@tomra.com',
      id: '903381c1-bfe4-419a-a02d-f2d9c0c7e003',
      appContext: 'Return and Earn',
      phoneNumber: '+61412345678'
    },
    {
      firstName: 'Test',
      lastName: 'Tomra',
      email: 'test02@tomra.com',
      id: '5b1b5b39-fad3-4e2e-9028-2f743b811794',
      appContext: 'Recycle Rewards',
      phoneNumber: '+61412345679'
    }
  ]
}

// User detail response for UserInfoPage tests (ID: 26ee710e-042c-4cbe-aa68-943a317c47e2)
export const userSearchByIdResponse = {
  data: {
    id: '26ee710e-042c-4cbe-aa68-943a317c47e2',
    email: 'mytomratest+test2@gmail.com',
    firstName: 'Democenter Two',
    lastName: 'Austria',
    appContext: 'myTOMRA',
    phoneNumber: '+436641234567',
    activeCountryState: 'AU-NSW',
    created: '2018-07-31T13:43:08.583Z',
    scheduledDeleteAt: '2024-08-18T04:51:39.488744Z',
    moneyStatistics: [
      {
        countryAndState: 'AU-NSW',
        currency: 'AUD',
        activePayoutMethod: 'PAYPAL',
        recycledStatistics: { totalAmount: 1.39, reverseVendingAmount: 1.39, bagdropAmount: 0.0 },
        payoutStatistics: { totalAmount: 1.39, voucherAmount: 0.0, transferAmount: 1.39, donationAmount: 0.0 },
        balanceStatistics: { totalAmount: 0.0, unredeemedVoucherAmount: 0.0, balanceAmount: 0.0 }
      }
    ]
  }
}

// User detail response for UsersPage navigation test (ID: 903381c1-bfe4-419a-a02d-f2d9c0c7e003)
export const userSearchByIdResponseForUsersPage = {
  data: {
    id: '903381c1-bfe4-419a-a02d-f2d9c0c7e003',
    email: 'test01@tomra.com',
    firstName: 'Test',
    lastName: 'Test',
    appContext: 'Return and Earn',
    phoneNumber: '+61412345678',
    activeCountryState: 'AU-NSW',
    created: '2018-07-31T13:43:08.583Z',
    moneyStatistics: [
      {
        countryAndState: 'AU-NSW',
        currency: 'AUD',
        activePayoutMethod: 'PAYPAL',
        recycledStatistics: { totalAmount: 1.0, reverseVendingAmount: 1.0, bagdropAmount: 0.0 },
        payoutStatistics: { totalAmount: 1.0, voucherAmount: 0.0, transferAmount: 1.0, donationAmount: 0.0 },
        balanceStatistics: { totalAmount: 0.0, unredeemedVoucherAmount: 0.0, balanceAmount: 0.0 }
      }
    ]
  }
}

export const userConsumerSessionsResponse = {
  data: [
    {
      consumerSession: {
        dpuid: '9360035381533044570384602',
        created: '2018-07-31T13:43:08.583Z',
        rvmSerial: '936003538',
        itemCount: 1,
        refund: 0.09,
        currency: 'AUD',
        userId: '26ee710e-042c-4cbe-aa68-943a317c47e2',
        latestStatus: 'PAID_OUT',
        voucherBarcode: '2201234000097',
        errorCategory: null
      }
    }
  ]
}

export const userConsumerSessionsResponseForUsersPage = {
  data: [
    {
      consumerSession: {
        dpuid: '9360035381533044570384603',
        created: '2018-07-31T13:43:08.583Z',
        rvmSerial: '936003538',
        itemCount: 1,
        refund: 0.09,
        currency: 'AUD',
        userId: '903381c1-bfe4-419a-a02d-f2d9c0c7e003',
        latestStatus: 'PAID_OUT',
        voucherBarcode: '2201234000098',
        errorCategory: null
      }
    }
  ]
}

export const userPayoutResponse = {
  data: [
    {
      id: '153969144949000003',
      created: '2018-10-16T12:04:09.490Z',
      currency: 'AUD',
      amount: 0.63,
      clearingHouse: 'TOMRA_INTERNAL',
      paymentProvider: 'PAYPAL',
      userId: '26ee710e-042c-4cbe-aa68-943a317c47e2',
      latestStatus: 'PAID_OUT',
      errorCategory: null,
      payoutResults: [
        { payoutId: '153969144949000003', version: 0, status: 'PENDING', externalId: null, finalized: null },
        {
          payoutId: '153969144949000003',
          version: 1,
          status: 'PAID_OUT',
          externalId: '40P07451KT626534A',
          finalized: '2018-10-16T12:04:24Z'
        }
      ]
    },
    {
      id: '153121527831600001',
      created: '2018-07-10T09:34:38.320Z',
      currency: 'AUD',
      amount: 0.18,
      clearingHouse: 'TOMRA_INTERNAL',
      paymentProvider: 'PAYPAL',
      userId: '26ee710e-042c-4cbe-aa68-943a317c47e2',
      latestStatus: 'PAID_OUT',
      errorCategory: null,
      payoutResults: [
        {
          payoutId: '153121527831600001',
          version: 0,
          status: 'PAID_OUT',
          externalId: '6LP23752GH132803R',
          finalized: '2018-07-10T09:34:58Z'
        }
      ]
    }
  ]
}

export const pendingBagsByUserIdResponse = {
  data: [
    {
      bagtag: '036010147744626138617597',
      created: '2018-07-10T09:34:38.320Z',
      userId: '26ee710e-042c-4cbe-aa68-943a317c47e2'
    }
  ],
  meta: {
    totalItems: 1,
    links: {}
  }
}

const externalLocations = [
  {
    externalId: '0',
    name: 'Bourke Laundry Service Inc',
    address: '32 Richard Street',
    city: 'Bourke',
    zipCode: '2840',
    state: 'NSW',
    latitude: -30.09042,
    longitude: 145.93786,
    openingHours: 'Monday to Friday 8am to 12.30pm, Saturday and Sunday open 24 hours',
    collectionPointType: 'OTC',
    created: null,
    lastUpdated: null
  },
  {
    externalId: '1',
    name: 'Channings Dareton',
    address: '1845 Silver City Highway',
    city: 'Dareton',
    zipCode: '2717',
    state: 'NSW',
    latitude: -34.09201,
    longitude: 142.03209,
    openingHours: 'Monday to Friday 10am to 4.30pm and Saturday 8.30am to 12pm, Sunday open 24 hours',
    collectionPointType: 'OTC',
    created: null,
    lastUpdated: null
  },
  {
    externalId: '4',
    name: 'Warrumbungle Waste',
    address: '4202 Baradine Road',
    city: 'Coonabarabran',
    zipCode: '2357',
    state: 'NSW',
    latitude: -31.25342,
    longitude: 149.25479,
    openingHours: 'Monday to Friday 8am to 4.30pm, Saturday and Sunday 8am to 5pm',
    collectionPointType: 'OTC',
    created: null,
    lastUpdated: null
  }
]

export const externalLocationsResponse = {
  data: externalLocations
}

export const updatedExternalLocationsResponse = {
  data: {
    diff: {
      added: [
        {
          externalId: '5',
          name: 'Warrumbungle Shire Council - Dunedoo',
          address: '128 Avonside Road',
          city: 'Dunedoo',
          zipCode: '2844',
          state: 'NSW',
          latitude: -32.03391,
          longitude: 149.37365,
          openingHours: 'Monday to Friday 2.30pm to 4.30pm and Sunday 8.30am to 4.30pm, Saturday closed',
          collectionPointType: 'OTC',
          created: null,
          lastUpdated: null
        },
        {
          externalId: '9',
          name: 'Rylstone Foodworks',
          address: '23 Louee Street',
          city: 'Rylstone',
          zipCode: '2849',
          state: 'NSW',
          latitude: -32.79519,
          longitude: 149.97124,
          openingHours: 'Monday to Friday 1pm to 4pm and Saturday 1pm to 3pm, Sunday closed',
          collectionPointType: 'OTC',
          created: null,
          lastUpdated: null
        }
      ],
      removed: [
        {
          externalId: '1',
          name: 'Channings Dareton',
          address: '1845 Silver City Highway',
          city: 'Dareton',
          zipCode: '2717',
          state: 'NSW',
          latitude: -34.09201,
          longitude: 142.03209,
          openingHours: 'Monday to Friday 10am to 4.30pm and Saturday 8.30am to 12pm, Sunday open 24 hours',
          collectionPointType: 'OTC',
          created: null,
          lastUpdated: null
        }
      ],
      updated: [
        {
          oldValue: externalLocations[2],
          newValue: {
            externalId: '4',
            name: 'Warrumbungle Waste Inc',
            address: '4203 Baradine Road',
            city: 'Conabarabran',
            zipCode: '2354',
            state: 'NSW',
            latitude: -31.25323,
            longitude: 149.25445,
            openingHours: 'Monday to Friday 8am to 4.30pm, Saturday and Sunday 8am to 6pm',
            collectionPointType: 'OTC',
            created: null,
            lastUpdated: null
          }
        }
      ]
    },
    fileId: 'e654c8bb-9469-4916-81cc-5b41672c2c82'
  }
}

export const externalLocationsValidationErrorResponse = {
  data: {
    errors: {
      duplicateIds: [2, 3],
      linesWithIllegalPositionValues: [3, 4],
      linesWithMissingRequiredValues: [6, 7],
      linesWithWrongColumnCount: [2, 3, 4, 5, 6, 7]
    }
  }
}

export const bagsResponse = {
  meta: {
    totalItems: 33,
    links: {
      next: 'appContext=RETURNANDEARN&from=2025-01-01T00:00:00.00Z&to=2025-01-31T23:59:59.99Z&limit=2&offset=2'
    }
  },
  data: [
    {
      bagTag: '036020100000000095943015',
      amount: 31.0,
      processedAt: '2021-02-02T00:43:11.201Z',
      storeReference: 'Tomra Recycling Centre Seventeen Mile Rocks'
    },
    {
      bagTag: '036020100000000119525531',
      amount: 52.9,
      processedAt: '2021-02-01T21:52:44.105Z',
      storeReference: 'Tomra Recycling Centre Crestmead'
    }
  ]
}

export const bagSearchResponse = {
  data: {
    scannedBag: {
      bagtag: '036010147744626138617597',
      userId: '800b4503-8bbc-4b15-9771-aeda2b7bd1d7',
      created: '2022-08-18T04:51:39.488744Z',
      receivedBy: '1108'
    },
    consumerSessions: [
      {
        dpuid: '987654321001234567891112',
        created: '2021-12-07T10:00:00Z',
        rvmSerial: '936010228',
        itemCount: 1,
        refund: 0.1,
        currency: 'AUD',
        userId: 'd19d6778-5921-4142-9069-7cc14744a6b9',
        latestStatus: 'EXPIRED',
        voucherBarcode: '980123456780',
        errorCategory: null
      }
    ]
  }
}

export const bagSearchCharityResponse = {
  data: {
    scannedBag: {
      bagtag: '036010147744626138617598',
      charityId: 'c018fa38-2fc3-4a07-8230-1bd913a50749',
      created: '2022-08-18T04:51:39.488744Z',
      receivedBy: '1108'
    },
    consumerSessions: [
      {
        dpuid: '987654321001234567891112',
        created: '2021-12-07T10:00:00Z',
        rvmSerial: '936010228',
        itemCount: 1,
        refund: 0.1,
        currency: 'AUD',
        userId: null,
        latestStatus: null,
        voucherBarcode: '980123456780',
        errorCategory: null
      }
    ]
  }
}

export const consumerSessionResponse = {
  data: {
    consumerSession: {
      dpuid: '987654321001234567891112',
      created: '2021-12-07T10:00:00Z',
      rvmSerial: '936010228',
      itemCount: 1,
      refund: 0.1,
      currency: 'AUD',
      userId: 'd19d6778-5921-4142-9069-7cc14744a6b9',
      latestStatus: 'EXPIRED',
      voucherBarcode: '980123456780',
      errorCategory: null
    },
    payouts: [
      {
        id: '163887187451400003',
        created: '2021-12-07T10:11:14.515013Z',
        currency: 'AUD',
        amount: 0.1,
        clearingHouse: 'EXCHANGEFORCHANGE',
        paymentProvider: 'E_VOUCHER',
        userId: 'd19d6778-5921-4142-9069-7cc14744a6b9',
        latestStatus: 'EXPIRED',
        errorCategory: null,
        payoutResults: [
          { payoutId: '163887187451400003', version: 0, status: 'EXPIRED', externalId: null, finalized: null }
        ]
      }
    ]
  }
}

export const payoutResponse = {
  data: {
    payout: {
      id: '163887187451400003',
      created: '2021-12-07T10:11:14.515013Z',
      currency: 'AUD',
      amount: 0.1,
      clearingHouse: 'EXCHANGEFORCHANGE',
      paymentProvider: 'E_VOUCHER',
      userId: 'd19d6778-5921-4142-9069-7cc14744a6b9',
      latestStatus: 'EXPIRED',
      errorCategory: null,
      payoutResults: [
        {
          payoutId: '163887187451400003',
          version: 0,
          status: 'EXPIRED',
          externalId: '54M502438C9746234',
          finalized: '2018-04-16T08:25:17Z'
        }
      ]
    },
    consumerSessions: [
      {
        dpuid: '987654321001234567891112',
        created: '2021-12-07T10:00:00Z',
        rvmSerial: '936010228',
        itemCount: 1,
        refund: 0.1,
        currency: 'AUD',
        userId: null,
        latestStatus: null,
        voucherBarcode: '980123456780',
        errorCategory: null
      }
    ]
  }
}

export const managerNotesResponse = {
  data: [
    {
      id: 249,
      sourceId: '1179c981-5bcb-4613-877b-4cdd658a9d14',
      created: '2022-03-24T12:11:00.609687Z',
      updated: null,
      name: 'Test Testesem',
      email: 'test@tomra.com',
      notes: 'This is a very important manager note'
    }
  ]
}

export const userEventResponse = {
  data: [
    {
      userId: 'userId',
      type: 'EMAIL_UPDATED',
      timestamp: '2019-06-07T20:21:22Z',
      comment: 'new@email.com'
    }
  ]
}

export const readableDateOptions: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
}

export const BROWSER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone
